import type { CompanyFull, CompanyBase, CompanyType } from "../types/company";
import type { IngredientType, Item } from "../types/item";
import { CompanyInfo } from "./CompanyInfo";
import type { AiDietaryPreferences } from "../types/aiDietaryPreferences";
import { CategoryGrid } from "./CategoryGrid";
import { Slider } from "./Slider";
import { PopularItems } from "./PopularItems";
import { useLanguage } from "../contexts/LanguageContext";
import { NewItems } from "./NewItems";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { apiService } from "../services/api";
import { useAiDietaryPreferences } from "../contexts/AiDietaryPreferencesContext";
import { ItemDetailModal } from "./ItemDetailModal";
import { useTranslation } from "react-i18next";
import { useItemModal } from "@/contexts/ItemModalProvider";
import { useCart } from "@/contexts/CartProvider";
import { withIngredients } from "@/utils/with";
import { useCompanies } from "@/hooks/useCompanies";

export function HomePage() {
  const { restaurantId, categoryId } = useParams();

  const [companyInfo, setCompanyInfo] = useState<CompanyFull | null>(null);
  const { aiDietaryPreferences } = useAiDietaryPreferences();
  const [isItemModalOpen, setIsItemModalOpen] = useState(false);
  const [itemInModal, setItemInModal] = useState<Item | null>(null);

  const { addToCart } = useCart();

  const { data: companies, isLoading: isCompaniesLoading } = useCompanies();

  const { open: openItemModal } = useItemModal();

  const { t } = useTranslation();

  const { itemId } = useParams();

  useEffect(() => {}, [itemId]);

  const onAddToCart = (
    item: Item,
    quantity: number,
    selectedIngredients = {}
  ) => {
    const itemWithCompany = {
      ...item,
      company_id: companyInfo?.id,
    };

    addToCart({
      item: itemWithCompany,
      selectedIngredients,
      quantity,
    });
  };

  const onItemClick = async (item: Item) => {
    const itemWithIngredients = await withIngredients(item);

    const company = {
      id: companyInfo?.id,
      name: companyInfo?.name,
      address: companyInfo?.settings.address,
      workingHours: [[], []],
      image: companyInfo?.settings.logo,
    };

    // open item modal
    openItemModal({
      item: itemWithIngredients,
      ctaText: "Order",
      onCtaClick: (ingredients, quantity) => {
        addToCart(company, {
          item: itemWithIngredients,
          ingredients,
          quantity,
        });
      },
      showQuantitySelector: true,
      ingredientGroups: itemWithIngredients.ingredientGroups,
    });
  };

  useEffect(() => {
    if (!restaurantId) return;
    apiService.getCompanyInfo(restaurantId).then((company) => {
      setCompanyInfo(company);
    });
  }, [restaurantId]);

  return (
    <div>
      {/* <Header
        onMenuClick={() => {}}
        onSearchClick={() => {}}
        companyInfo={companyInfo}
        currentView={"home"}
        onCheckoutClick={() => {}}
        setShouldShowPaymentForm={() => {}}
      /> */}
      <div className="min-h-screen bg-gray-50">
        <Slider selectedCompany={companyInfo} />

        <PopularItems
          selectedCompany={companyInfo}
          onItemClick={onItemClick}
          onAddToCart={(item: Item) => {
            if (onAddToCart) onAddToCart(item, 1, {});
          }}
        />

        <NewItems
          selectedCompany={companyInfo}
          onItemClick={onItemClick}
          onAddToCart={(item: Item) => {
            if (onAddToCart) onAddToCart(item, 1, {});
          }}
        />

        <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8 py-8 sm:py-12">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              {t("home.explore_menu")}
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
              {t("home.discover_dishes")}
            </p>
          </div>

          <CategoryGrid
            initialSelectedCategoryId={categoryId}
            selectedCompany={companyInfo}
            onItemClick={onItemClick}
            onAddToCart={(item: Item) =>
              onAddToCart && onAddToCart(item, 1, {})
            }
            aiDietaryPreferences={aiDietaryPreferences}
            onScrollFinish={() => {
              if (itemId) {
                apiService.getItem(itemId).then((item) => {
                  setItemInModal(item);
                });
                setTimeout(() => {
                  setIsItemModalOpen(true);
                }, 2000);
              }
            }}
          />
        </div>

        <CompanyInfo company={companyInfo} />

        {/* <ItemDetailModal
          item={itemInModal as Item}
          isOpen={isItemModalOpen}
          onClose={() => {
            setIsItemModalOpen(false);
          }}
          onAddToCart={(
            item: Item,
            quantity: number,
            ingredientIds: string[]
          ) => {
            onAddToCart(item, quantity, ingredientIds);
          }}
        /> */}
      </div>
    </div>
  );
}
